import React, { useEffect, useState } from "react";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import api, { clearAccessToken } from "../api/api";
import { clearProfileCache } from "../api/profileApi";
 
const LeftSidebar = () => {
  const location = useLocation();
 // const [openEventMenu, setOpenEventMenu] = useState(false);
  const [openEventMenu, setOpenEventMenu] = useState(true);
  const navigate = useNavigate();
  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}

    clearAccessToken();
    clearProfileCache();
    localStorage.removeItem("hasProfessionalProfile");
    sessionStorage.clear();
  
    navigate("/login", { replace: true });
  };

  // Auto-open submenu when child route is active
  useEffect(() => {
    if (
      location.pathname.startsWith("/events") ||
      location.pathname.startsWith("/list-view")
    ) {
      setOpenEventMenu(true);
    }
  }, [location.pathname]);

  return (
    <div className="left-sidebar d-flex flex-column">
      
      <div className="sidebar-logo">
        <img src="/images/skedq.png" className="img-fluid" alt="Logo" />
      </div>

      <ul className="nav flex-column gap-2 sidebar-menu">
        
        <li className={`nav-item ${location.pathname === "/dashboard" ? "active" : ""}`}>
          <NavLink to="/dashboard" className="nav-link d-flex align-items-center gap-2">
            <img src="/icons/home.svg" alt="Home" />
            <span>Home</span>
          </NavLink>
        </li>

        
        <li
          className={`nav-item nav_submenu 
            ${openEventMenu ? "default-open" : ""}
            ${
              location.pathname.startsWith("/events") ||
              location.pathname.startsWith("/list-view")
                ? "active"
                : ""
            }
          `}
        >
          <div className="pe-2 d-flex align-items-center justify-content-between">
            <NavLink
              to="/events"
              className="nav-link d-flex align-items-center gap-2 text-decoration-none flex-grow-1"
            >
              <img src="/icons/event.svg" alt="Event" />
              <span>Event List</span>
            </NavLink>

            <button
              type="button"
              className="btn btn-link p-0 ms-2"
              onClick={(e) => {
				  e.stopPropagation();   
				  setOpenEventMenu((prev) => !prev);
				}}
            >
              <i
                className={`bi ${
                  openEventMenu ? "bi-chevron-up" : "bi-chevron-down"
                }`}
              />
            </button>
          </div>
          
          {openEventMenu && (
            <ul className="nav flex-column submenu ps-4">
              <li
                className={`nav-item ${
                  location.pathname === "/events" ? "active" : ""
                }`}
              >
                <NavLink to="/events" className="nav-link">
                  Calendar View
                </NavLink>
              </li>

              <li
                className={`nav-item ${
                  location.pathname === "/list-view" ? "active" : ""
                }`}
              >
                <NavLink to="/list-view" className="nav-link">
                  List View
                </NavLink>
              </li>
            </ul>
          )}
        </li>
        
        <li className={`nav-item ${location.pathname === "/profile" ? "active" : ""}`}>
          <NavLink to="/profile" className="nav-link d-flex align-items-center gap-2">
            <img src="/icons/profile.svg" alt="Profile" />
            <span>Profile Settings</span>
          </NavLink>
        </li>
        
        <li className={`nav-item ${location.pathname === "/contact" ? "active" : ""}`}>
          <NavLink to="/contact" className="nav-link btn-contact d-flex align-items-center gap-2">
            <img src="/icons/phone.svg" alt="Contact" />
            <span>Contact Us</span>
          </NavLink>
        </li>
      </ul>
      
      <div className="logout mt-auto">
        <button
                  type="button"
                  className="nav-link d-flex align-items-center gap-2 border-0 bg-transparent"
                  onClick={logout}
        >
        <img src="/icons/logout.svg" alt="Logout" />
                  Logout
        </button>
        </div>
    </div>
  );
};

export default LeftSidebar;
